import { c as _c } from "react/compiler-runtime";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
import SelectGroupModalCard from "./SelectGroupModalCard";
export default function SelectGroupModalItems(t0) {
  const $ = _c(14);
  const {
    groups,
    selectedGroupId,
    loading,
    onGroupSelect,
    onGroupClear,
    emptyStateMessage: t1
  } = t0;
  const emptyStateMessage = t1 === undefined ? "No groups found." : t1;
  if (loading) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-pb-4"><CircleLoader size={CircleLoaderSize.SMALL} /></div>;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  if (groups.length === 0) {
    let t2;
    if ($[1] !== emptyStateMessage) {
      t2 = <div className="tw-rounded-xl tw-border tw-border-dashed tw-border-white/[0.08] tw-bg-iron-950/60 tw-px-4 tw-py-5 tw-text-center"><p className="tw-mb-0 tw-text-sm tw-text-iron-400">{emptyStateMessage}</p></div>;
      $[1] = emptyStateMessage;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] !== groups || $[4] !== onGroupClear || $[5] !== onGroupSelect || $[6] !== selectedGroupId) {
    let t3;
    if ($[8] !== onGroupClear || $[9] !== onGroupSelect || $[10] !== selectedGroupId) {
      t3 = group => <SelectGroupModalCard key={group.id} group={group} isSelected={selectedGroupId === group.id} onSelect={onGroupSelect} onClear={onGroupClear} />;
      $[8] = onGroupClear;
      $[9] = onGroupSelect;
      $[10] = selectedGroupId;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    t2 = groups.map(t3);
    $[3] = groups;
    $[4] = onGroupClear;
    $[5] = onGroupSelect;
    $[6] = selectedGroupId;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[12] !== t2) {
    t3 = <div className="tw-grid tw-grid-cols-1 tw-gap-2">{t2}</div>;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}